// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_f1-2";
export var aiChatCartContainerExit = "_f1-4";
export var aiChatContainerLarge = "_f1-0";
export var aiChatContainerSmall = "_f1-1";
export var aiChatIcon = "_f1-6";
export var slideInFromRight = "_f1-3";
export var slideOutToRight = "_f1-5";